
interface Props {
  number: number;
}

const IndicatorNumber = ({ number }: Props) => {
  if(!number) return null;
  return (
    <div data-cy="indicator-number" className="indicator-number">
      <p className="flex" data-cy="indicator-number-value">
        {number}
      </p>
    </div>
  );
};

export default IndicatorNumber;
